import Loading from '@/components/ui/Loading';

/**
 * O corpo do diálogo enquanto algo demora: carregar o rascunho salvo, ou gerar
 * o texto. O que está acontecendo é dito no título do diálogo, então aqui fica
 * só a animação.
 */
export default function SurveyGeneratingState() {
    return (
        <div className="flex h-full min-h-[320px] flex-col items-center justify-center text-center">
            <Loading className="h-auto py-0" size={168} />
        </div>
    );
}
